import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { ChessGridBackground } from 'styles/consts'
import {
  normalizeAndConvertAspectRatioForCSS,
  SQUARE_ASPECT_RATIO
} from 'utils/aspectRatio'

export const VersionItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.borderColor};
  padding-bottom: 16px;

  &:last-child {
    border-bottom: none;
  }
`

export const MetadataBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const MetadataBadge = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 8px 16px;
  color: ${COLORS.secondaryDark};
  border-radius: 4px;
  background-color: ${COLORS.primaryExtraLight};
`

export const MediaWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: ${normalizeAndConvertAspectRatioForCSS(SQUARE_ASPECT_RATIO)};
  background: ${COLORS.secondaryUltraLight};
  border-radius: 8px;
  overflow: hidden;

  ${ChessGridBackground}
`

export const VideoElement = styled.video<{ $isLoading: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${props => (props.$isLoading ? 0 : 1)};
  transition: opacity 0.3s ease;
`

export const ThumbnailImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const ImageElement = styled.img<{ $isLoading: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${props => (props.$isLoading ? 0 : 1)};
  transition: opacity 0.3s ease;
`
